var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_c("div", {
    staticClass: "top-wrap"
  }), _c("div", {
    staticClass: "titleBar"
  }, [_c("div", {
    staticClass: "img-wrap",
    on: {
      click: _vm.back
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/Nav-Back.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "center"
  }, [_vm._v(_vm._s(_vm.$t("AllTopics")))]), _c("div", {
    staticClass: "img-wrap"
  })]), _c("div", {
    staticClass: "main"
  }, [_c("div", {
    staticClass: "input-con"
  }, [_c("img", {
    staticClass: "search-icon",
    attrs: {
      src: require("../../assets/images/Search.png"),
      alt: ""
    }
  }), _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value,
      expression: "value"
    }],
    ref: "inputs",
    attrs: {
      type: "text",
      placeholder: "Search"
    },
    domProps: {
      value: _vm.value
    },
    on: {
      input: [function ($event) {
        if ($event.target.composing) return;
        _vm.value = $event.target.value;
      }, function ($event) {
        $event.stopPropagation();
        return _vm.input.apply(null, arguments);
      }]
    }
  }), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isEmpty,
      expression: "!isEmpty"
    }],
    staticClass: "clear-icon",
    on: {
      click: _vm.clear
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/close.png"),
      alt: ""
    }
  })])]), _vm.isInput ? _c("div", {
    staticClass: "menu-list"
  }, _vm._l(_vm.searchTopicList, function (item) {
    return _c("div", {
      key: item.content,
      staticClass: "menu-item",
      on: {
        click: function click($event) {
          return _vm.toTopic(item.topicId);
        }
      }
    }, [_c("div", {
      staticClass: "left"
    }, [_c("img", {
      attrs: {
        src: require("../../assets/images/Topic-list-icon-gray.png"),
        alt: ""
      }
    }), _c("span", [_vm._v(_vm._s(item.content))])]), _c("span", {
      staticClass: "join"
    }, [_vm._v(_vm._s(item.viewCount) + " " + _vm._s(_vm.$t("Join")))])]);
  }), 0) : _vm._e(), !_vm.isInput ? _c("van-list", {
    attrs: {
      finished: _vm.finished,
      "finished-text": _vm.$t("NoMoreContents")
    },
    on: {
      load: _vm.onLoad
    },
    model: {
      value: _vm.loading,
      callback: function callback($$v) {
        _vm.loading = $$v;
      },
      expression: "loading"
    }
  }, _vm._l(_vm.hotTopicList, function (item) {
    return _c("van-cell", {
      key: item.content,
      staticClass: "menu-item",
      on: {
        click: function click($event) {
          return _vm.toTopic(item.topicId);
        }
      }
    }, [_c("div", {
      staticClass: "left"
    }, [_c("img", {
      attrs: {
        src: require("../../assets/images/Topic-list-icon-gray.png"),
        alt: ""
      }
    }), _c("span", [_vm._v(_vm._s(item.content))])]), _c("span", {
      staticClass: "join"
    }, [_vm._v(_vm._s(item.viewCount) + " " + _vm._s(_vm.$t("Join")))])]);
  }), 1) : _vm._e()], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };